module.exports = __webpack_public_path__ + "img/1574478347.e14fdbd2.jpg";